import { render, staticRenderFns } from "./fl44-unknown-volume-supplier-info-block.vue?vue&type=template&id=d0da35c2&"
import script from "./fl44-unknown-volume-supplier-info-block.vue?vue&type=script&lang=js&"
export * from "./fl44-unknown-volume-supplier-info-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0da35c2')) {
      api.createRecord('d0da35c2', component.options)
    } else {
      api.reload('d0da35c2', component.options)
    }
    module.hot.accept("./fl44-unknown-volume-supplier-info-block.vue?vue&type=template&id=d0da35c2&", function () {
      api.rerender('d0da35c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/fl44-unknown-volume/partials/fl44-unknown-volume-supplier-info-block.vue"
export default component.exports